// extracted by mini-css-extract-plugin
export default {"configRow":"security_configRow__NjHle","configLabel":"security_configLabel__ha03v","switchWrapper":"security_switchWrapper__YeqsR"};